export default "__VITE_ASSET__045ca1aa__"